<!-- eslint-disable vue/require-v-for-key -->
<template>
  <div class="grid h-screen grid-cols-10 gap-1 mx-5 my-5 shadow-xl body">
    <div class="col-span-2 mx-3 border-black shadow-lg rounded-xl">
      <div class="w-full mx-auto my-auto text-left">
        <h2 class="mt-5 font-bold text-black">Main Menu</h2>
        <ul class="w-auto ml-2">
          <p clas="text-black">Main Menu</p>
          <li class="inline-flex w-full px-2 py-4">
            <svg
              class="w-12 h-8 text-black"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" />
              <path
                d="M21 14l-3 -3h-7a1 1 0 0 1 -1 -1v-6a1 1 0 0 1 1 -1h9a1 1 0 0 1 1 1v10"
              />
              <path d="M14 15v2a1 1 0 0 1 -1 1h-7l-3 3v-10a1 1 0 0 1 1 -1h2" />
            </svg>
            <span class="ml-1 text-sm font-bold text-black">Messages</span>
          </li>
          <li class="inline-flex w-full px-2 py-4">
            <svg
              class="w-12 h-8 text-black"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" />
              <path
                d="M8 9l5 5v7h-5v-4m0 4h-5v-7l5 -5m1 1v-6a1 1 0 0 1 1 -1h10a1 1 0 0 1 1 1v17h-8"
              />
              <line x1="13" y1="7" x2="13" y2="7.01" />
              <line x1="17" y1="7" x2="17" y2="7.01" />
              <line x1="17" y1="11" x2="17" y2="11.01" />
              <line x1="17" y1="15" x2="17" y2="15.01" />
            </svg>
            <span class="ml-1 text-sm font-bold text-black">Communauté</span>
          </li>
          <li class="inline-flex w-full px-2 py-4">
            <svg
              class="w-12 h-8 text-slate-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <span class="ml-1 text-sm font-bold text-black">Profil</span>
          </li>
          <li class="inline-flex px-2 py-4">
            <svg
              class="w-12 h-8 text-slate-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
              />
            </svg>
            <span class="ml-1 text-sm font-bold text-black">Nouveautés</span>
          </li>
        </ul>
      </div>
      <div class="items-start mx-auto my-auto mt-5 text-left">
        <h2 class="text-lg font-bold text-black">Explorer</h2>
        <ul class="w-auto ml-2">
          <li class="inline-flex w-full px-2 py-4">
            <svg
              class="w-12 h-8 text-slate-600"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" />
              <path
                d="M6 4h11a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-11a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1m3 0v18"
              />
              <line x1="13" y1="8" x2="15" y2="8" />
              <line x1="13" y1="12" x2="15" y2="12" />
            </svg>
            <span class="ml-1 text-sm font-bold text-black">Pages</span>
          </li>
          <li class="inline-flex w-full px-2 py-4 align-middle">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              class="w-12 h-8 text-slate-600"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0z"
              ></path>
            </svg>
            <span class="ml-1 font-bold text-black">Enregistrés</span>
          </li>
          <li class="inline-flex w-full px-2 py-4">
            <svg
              class="w-12 h-8 text-slate-600"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polygon points="3 11 22 2 13 21 11 13 3 11" />
            </svg>
            <span class="ml-1 font-bold text-black">Mes publications</span>
          </li>
          <li class="inline-flex px-2 py-4">
            <svg
              class="w-12 h-8 text-slate-600"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path stroke="none" d="M0 0h24v24H0z" />
              <rect x="4" y="5" width="16" height="16" rx="2" />
              <line x1="16" y1="3" x2="16" y2="7" />
              <line x1="8" y1="3" x2="8" y2="7" />
              <line x1="4" y1="11" x2="20" y2="11" />
              <rect x="8" y="15" width="2" height="2" />
            </svg>
            <span class="ml-1 font-bold text-black">Evenements</span>
          </li>
          <ul v-for="(category, index) in posts" :key="index">
            <li>Je suis là</li>
            <li>{{ category.name }}</li>
          </ul>
        </ul>
        <div></div>
      </div>
    </div>
    <div class="relative max-h-screen col-span-6 overflow-y-auto bg-white">
      <h2 class="text-xl font-bold">Récentes publications</h2>
      <!-- <div class="fixed top-0 left-0 right-0">Récentes publications</div> -->
      <div class="shadow-xl">
        <form action="">
          <textarea
            name=""
            id=""
            placeholder="Exprimez-vous..."
            class="w-full p-5 my-auto text-black shadow-xl border-1 outline-0"
          ></textarea>
          <div class="flex items-center justify-between">
            <div class="flex items-center justify-between">
              <svg
                class="w-8 h-8 text-slate-500 emojipicker"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                @click="activateEmoji"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <svg
                class="w-8 h-8 text-slate-500 linkpicker"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                @click="openPopup"
              >
                <path stroke="none" d="M0 0h24v24H0z" />
                <path
                  d="M10 14a3.5 3.5 0 0 0 5 0l4 -4a3.5 3.5 0 0 0 -5 -5l-.5 .5"
                />
                <path
                  d="M14 10a3.5 3.5 0 0 0 -5 0l-4 4a3.5 3.5 0 0 0 5 5l.5 -.5"
                />
              </svg>
              <select
                name="category"
                class="max-w-sm mx-auto text-black bg-transparent outline-0"
              >
                <option value="" selected disabled hidden>
                  Choisir Categorie
                </option>
                <option
                  v-for="(category, index) in categoriesStore.categories"
                  :key="index"
                  :value="category.id"
                >
                  {{ category.name }}
                </option>
              </select>
            </div>
            <div>
              <button
                class="select-none rounded-lg py-3 px-6 text-center align-middle font-sans text-xs font-bold uppercase text-black bg-blue-200 shadow-md shadow-gray-900/10 transition-all hover:shadow-lg hover:shadow-gray-900/20 active:opacity-[0.85] disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
                type="button"
                @click="addPost()"
              >
                PUBLIER
              </button>
            </div>
          </div>
          <!-- Start Popup -->
          <div>
            <div
              v-if="showPopup"
              class="fixed inset-0 flex items-center justify-center transition-opacity duration-300 bg-gray-900 bg-opacity-30"
            >
              <div
                class="max-w-md p-8 transition-transform duration-300 transform bg-white rounded shadow-md"
              >
                <h1 class="mb-4 text-2xl font-semibold">Ajouter un lien</h1>
                <div class="mb-4">
                  <label for="url" class="block mb-2 font-bold text-gray-700"
                    >Lien URL:</label
                  >
                  <input
                    type="url"
                    name="link"
                    placeholder="https://example.com"
                    pattern="https://.*"
                    required
                    class="w-full px-3 py-2 text-black border border-gray-300 rounded lienURL"
                  />
                </div>
                <button
                  type="button"
                  @click="verifyLink"
                  class="px-4 py-2 font-bold text-white transition duration-300 ease-in-out bg-green-500 rounded hover:bg-green-600"
                >
                  Ajouter
                </button>
                <button
                  type="button"
                  @click="closePopup"
                  class="px-4 py-2 ml-4 font-bold text-white transition duration-300 ease-in-out bg-red-500 rounded hover:bg-red-600"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
          <!-- End Popup -->
          <div>
            <EmojiPicker
              class="hidden EmojiPicker"
              :native="true"
              @select="onSelectEmoji"
            />
          </div>
        </form>
      </div>
      <div
        v-for="post in postsStore.posts"
        :key="post"
        class="flex flex-wrap items-center justify-center gap-10 my-8 align-center"
      >
        <!-- <div v-for="n in 10" :key="n"> -->
        <!-- </div> -->
        <!-- Card -->
        <div class="w-full p-6 bg-white rounded-md">
          <div class="flex items-center justify-between align-center">
            <div class="flex items-start justify-start gap-4 align-start">
              <img
                class="w-16 h-16 rounded-full"
                src="../../assets/avatar.jpg"
                alt=""
              />
              <div
                class="flex flex-col items-start font-medium dark:text-white"
              >
                <div class="text-black">{{ post.user.name }}</div>
                <div class="text-sm text-gray-500 dark:text-gray-400">
                  Joined {{ post.user.created_at }}
                </div>
              </div>
            </div>
            <button>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
              >
                <path
                  d="M12 27C13.6569 27 15 25.6569 15 24C15 22.3431 13.6569 21 12 21C10.3431 21 9 22.3431 9 24C9 25.6569 10.3431 27 12 27Z"
                  fill="black"
                />
                <path
                  d="M24 27C25.6569 27 27 25.6569 27 24C27 22.3431 25.6569 21 24 21C22.3431 21 21 22.3431 21 24C21 25.6569 22.3431 27 24 27Z"
                  fill="black"
                />
                <path
                  d="M36 27C37.6569 27 39 25.6569 39 24C39 22.3431 37.6569 21 36 21C34.3431 21 33 22.3431 33 24C33 25.6569 34.3431 27 36 27Z"
                  fill="black"
                />
              </svg>
            </button>
          </div>
          <p class="my-6 text-justify text-gray-500">{{ post.description }}</p>
          <div class="flex justify-between text-black">
            <button>Voir plus ...</button>
            <p>Posté depuis le {{ Date(post.created_at) }}</p>
          </div>
          <div class="h-1 my-6 bg-black rounded"></div>

          <div class="flex justify-between">
            <div class="flex gap-5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                class="like"
              >
                <path
                  d="M12.5 8.33339L11.6783 8.19673C11.6585 8.31606 11.6649 8.43827 11.697 8.55489C11.7292 8.6715 11.7863 8.77972 11.8645 8.87202C11.9427 8.96432 12.0401 9.0385 12.1498 9.08939C12.2595 9.14028 12.379 9.16667 12.5 9.16673V8.33339ZM3.33333 8.33339V7.50006C3.11232 7.50006 2.90036 7.58786 2.74408 7.74414C2.5878 7.90042 2.5 8.11238 2.5 8.33339H3.33333ZM5 17.5001H14.4667V15.8334H5V17.5001ZM15.4667 7.50006H12.5V9.16673H15.4667V7.50006ZM13.3225 8.47006L13.9933 4.44089L12.35 4.16673L11.6783 8.19673L13.3225 8.47006ZM12.35 2.50006H12.1717V4.16673H12.35V2.50006ZM9.3975 3.98423L7.3025 7.12923L8.68917 8.05423L10.7858 4.90923L9.3975 3.98423ZM6.60833 7.50006H3.33333V9.16673H6.60833V7.50006ZM2.5 8.33339V15.0001H4.16667V8.33339H2.5ZM16.9183 15.4901L17.9183 10.4901L16.285 10.1634L15.285 15.1634L16.9183 15.4901ZM7.3025 7.12923C7.22638 7.24332 7.12243 7.33687 7.00149 7.40156C6.88054 7.46625 6.74549 7.50008 6.60833 7.50006V9.16673C7.01989 9.1667 7.42507 9.06506 7.78792 8.87085C8.15077 8.67663 8.46006 8.39584 8.68833 8.05339L7.3025 7.12923ZM13.9933 4.44089C14.0331 4.20218 14.0205 3.95765 13.9562 3.72432C13.892 3.49098 13.7777 3.27444 13.6213 3.08974C13.4649 2.90504 13.2702 2.75662 13.0507 2.65478C12.8311 2.55295 12.592 2.50015 12.35 2.50006V4.16673L13.9933 4.44089ZM15.4667 9.16673C15.59 9.16668 15.7118 9.194 15.8232 9.24671C15.9347 9.29943 16.0331 9.37623 16.1113 9.47157C16.1895 9.56691 16.2456 9.67842 16.2755 9.79806C16.3054 9.9177 16.3092 10.0425 16.285 10.1634L17.9183 10.4901C17.9908 10.1274 17.9819 9.75325 17.8924 9.39446C17.8028 9.03568 17.6347 8.70123 17.4003 8.41524C17.1659 8.12924 16.8709 7.89881 16.5367 7.74055C16.2025 7.5823 15.8373 7.50016 15.4675 7.50006L15.4667 9.16673ZM14.4667 17.5001C15.0447 17.5001 15.6049 17.2998 16.0519 16.9334C16.4988 16.5669 16.805 16.0569 16.9183 15.4901L15.285 15.1634C15.2472 15.3525 15.145 15.5227 14.9957 15.6449C14.8465 15.767 14.6595 15.8337 14.4667 15.8334V17.5001ZM12.1717 2.50006C11.6229 2.50007 11.0827 2.63554 10.5989 2.89445C10.1151 3.15335 9.7019 3.52769 9.3975 3.98423L10.7858 4.90923C10.938 4.68088 11.1433 4.49363 11.3852 4.3641C11.6271 4.23458 11.8973 4.16678 12.1717 4.16673V2.50006ZM5 15.8334C4.77899 15.8334 4.56702 15.7456 4.41074 15.5893C4.25446 15.433 4.16667 15.2211 4.16667 15.0001H2.5C2.5 15.6631 2.76339 16.299 3.23223 16.7678C3.70107 17.2367 4.33696 17.5001 5 17.5001V15.8334Z"
                  fill="#B5B5B5"
                />
                <path
                  d="M6.66663 8.33337V16.6667"
                  stroke="#B5B5B5"
                  stroke-width="1.66667"
                />
              </svg>
              <span class="text-black">{{ post.number_of_likes }}</span>
            </div>
            <div class="flex gap-5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                class="comment"
              >
                <path
                  d="M2.88663 14.0234C1.66663 13.0476 1.66663 12.3092 1.66663 9.16673C1.66663 6.02423 1.66663 4.45256 2.88663 3.47673C4.10829 2.50006 6.07163 2.50006 9.99996 2.50006C13.9283 2.50006 15.8925 2.50006 17.1125 3.47673C18.3333 4.45256 18.3333 6.02423 18.3333 9.16673C18.3333 12.3092 18.3333 13.0476 17.1125 14.0234C15.8933 15.0001 13.9283 15.0001 9.99996 15.0001C7.90829 15.0001 6.83329 16.4484 4.99996 17.5001V14.8234C4.08829 14.6876 3.41746 14.4484 2.88663 14.0234Z"
                  stroke="#B5B5B5"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <span class="text-black">154</span>
            </div>
            <div class="flex gap-5">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                class="share"
              >
                <path
                  d="M18.1633 8.7883L14.4133 12.5383C14.2372 12.7144 13.9983 12.8134 13.7492 12.8134C13.5001 12.8134 13.2613 12.7144 13.0852 12.5383C12.909 12.3622 12.8101 12.1233 12.8101 11.8742C12.8101 11.6252 12.909 11.3863 13.0852 11.2102L15.2344 9.06252H12.8906C11.4354 9.06204 10.0213 9.54528 8.87064 10.4362C7.72002 11.3272 6.89819 12.5754 6.53438 13.9844C6.5036 14.1036 6.44964 14.2156 6.37558 14.314C6.30152 14.4123 6.20882 14.4951 6.10275 14.5577C5.99669 14.6202 5.87935 14.6612 5.75743 14.6784C5.63551 14.6956 5.5114 14.6886 5.39219 14.6578C5.27297 14.627 5.16099 14.5731 5.06262 14.499C4.96426 14.425 4.88145 14.3323 4.81891 14.2262C4.75638 14.1201 4.71535 14.0028 4.69816 13.8809C4.68098 13.759 4.68797 13.6349 4.71875 13.5156C5.18576 11.7037 6.24214 10.0985 7.72158 8.9529C9.20102 7.80725 11.0195 7.1862 12.8906 7.18751H15.2344L13.0867 5.03751C12.9106 4.86139 12.8117 4.62252 12.8117 4.37345C12.8117 4.12438 12.9106 3.88551 13.0867 3.70939C13.2628 3.53327 13.5017 3.43433 13.7508 3.43433C13.9999 3.43433 14.2387 3.53327 14.4148 3.70939L18.1648 7.45939C18.2523 7.5466 18.3216 7.65023 18.3688 7.76431C18.4161 7.87839 18.4403 8.00069 18.4402 8.12417C18.44 8.24765 18.4155 8.36989 18.368 8.48386C18.3205 8.59783 18.2509 8.70129 18.1633 8.7883ZM15 15.9375H3.4375V6.87501C3.4375 6.62637 3.33873 6.38792 3.16291 6.2121C2.9871 6.03629 2.74864 5.93751 2.5 5.93751C2.25136 5.93751 2.0129 6.03629 1.83709 6.2121C1.66127 6.38792 1.5625 6.62637 1.5625 6.87501V16.875C1.5625 17.1237 1.66127 17.3621 1.83709 17.5379C2.0129 17.7137 2.25136 17.8125 2.5 17.8125H15C15.2486 17.8125 15.4871 17.7137 15.6629 17.5379C15.8387 17.3621 15.9375 17.1237 15.9375 16.875C15.9375 16.6264 15.8387 16.3879 15.6629 16.2121C15.4871 16.0363 15.2486 15.9375 15 15.9375Z"
                  fill="#B5B5B5"
                />
              </svg>
              <span class="text-black">14</span>
            </div>
          </div>
        </div>
        <!-- Card End -->
      </div>
    </div>
    <div class="h-screen col-span-2 mx-3 bg-white rounded-lg shadow-lg">
      <div class="flex items-center justify-between my-8">
        <h2 class="mx-auto font-semibold text-left text-black">
          Evénements à venir
        </h2>
        <svg
          class="w-8 h-8 mx-auto text-slate-500"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>
      <hr />
    </div>
  </div>
</template>

<script>
let countEmoji = 0;
// import SuggestedCardPost from "@/components/website/SuggestedCardPost.vue";
import { usePostsStore } from "@/stores/post";
import { useCategoriesStore } from "@/stores/category";
import EmojiPicker from "vue3-emoji-picker";
import "vue3-emoji-picker/css";
export default {
  setup() {
    const postsStore = usePostsStore();
    const categoriesStore = useCategoriesStore();
    return {
      postsStore,
      categoriesStore,
    };
  },
  data() {
    return {
      countEmoji: 0,
      showPopup: false,
      url: "",
      posts: [],
    };
  },
  mounted() {
    this.postsStore.getPosts();
    this.categoriesStore.getCategories();
    // let categories = this.categoriesStore.categories;
  },
  name: "PostPage",
  components: {
    //SuggestedCardPost,
    EmojiPicker,
  },
  methods: {
    onSelectEmoji(emoji) {
      document.querySelector("textarea").value += emoji.i;
    },
    activateEmoji() {
      countEmoji++;
      if (countEmoji % 2 == 0) {
        document.querySelector(".EmojiPicker").classList.add("hidden");
      } else {
        document.querySelector(".EmojiPicker").classList.remove("hidden");
      }
    },
    openPopup() {
      this.showPopup = true;
    },
    closePopup() {
      this.showPopup = false;
    },
    verifyLink() {
      let lien = document.querySelector(".lienURL").value;
      this.url = lien;
      this.closePopup();
    },
    addPost() {
      let category_id = document.querySelector("select").value;
      let description = document.querySelector("textarea").value;
      this.postsStore.createPost(description, this.url, category_id);
      this.postsStore.getPosts;
      description = "";
    },
  },
};
</script>
